export const CREDSYSTEM_LOGIN_TOKEN = 'LOGIN_TOKEN';
export const CREDSYSTEM_LOGIN_REFRESH_TOKEN = 'LOGIN_TOKEN';
export const CREDSYSTEM_USER_TOKEN = 'USER_TOKEN';
export const CREDSYSTEM_USER_REFRESH_TOKEN = 'USER_REFRESH_TOKEN';
export const CREDSYSTEM_VALIDATION_TOKEN = 'VALIDATION_TOKEN';
export const CREDSYSTEM_VALIDATION_REFRESH_TOKEN = 'VALIDATION_TOKEN';
export const CREDSYSTEM_USER_SESSION_DATA = 'USER_SESSION_DATA';
export const CREDSYSTEM_USER_DOCUMENT = 'USER_DOCUMENT';
export const CREDSYSTEM_USER_PASSWORD = 'USER_PASSWORD';
export const CREDSYSTEM_APP_UID = 'APP_UID';
export const CREDSYSTEM_SHOW_INFO = 'SHOW_INFO';
